import { JSEncrypt } from "jsencrypt"
const { instance } = require('./url')

async function insertBank(nick_name, ada_routing_number, account_number, account_title) {
    const publicKey = '-----BEGIN PUBLIC KEY-----\n' +
        'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA8XOll60gschIrGcJq3vE\n' +
        '3oUVN2uHH+PpGQafNTadT9XU8iD3cwCItvP5U1yoolA71tCFJHjK3EWN+3N8kOrX\n' +
        'NK9k7Pg2l8na9ixoHulJSrzmMMUBw3zYoKiOZSVzzkUkF6FApu+hd/tiyNZfqaQF\n' +
        '6IN7K23YcQ8Akm3EQMvobEBF6tMOAHFCqcIymiI6CdqsVMqmQlNAUar2/nJ6W7ns\n' +
        'BSGV4kOTfrwevocPVXIcqllQBZab7uEE8gjsQB6p5NgiyJk/V30WdBUJ7fzzlyJo\n' +
        'AQ7HGEkrT17AdonuUlHLSZrsCL24dDmsKEV5Jxetb3KlTP0O6eC0WNaxc2RjbkiA\n' +
        'PQIDAQAB\n' +
        '-----END PUBLIC KEY-----\n'

    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(publicKey)

    let data = [
        ada_routing_number,
        account_number,
        account_title,
    ]

    for (let i = 0; i < 3; i++) {
        data[i] = encrypt.encrypt(data[i])
    }

    return await instance.post('/bank/', {
        'bank': {
            'nick_name': nick_name,
            'ada_routing_number': data[0],
            'account_number': data[1],
            'account_title': data[2],
        }
    }).then(
        (result) => {
            return result.data.bank
        }
    )
}

async function getCompanyBankNickNames() {
    return await instance.get('/bank/').then(
        (result) => {
            return result.data.banks
        },
    )
}

async function getBanks(company, privateKey) {
    return await instance.get('/bank/company/' + company).then(
        (data) => {
            const encrypt = new JSEncrypt()
            encrypt.setPrivateKey(privateKey)
            return data.data.banks.map((x) => {
                const vars = [
                    'ada_routing_number',
                    'account_number',
                    'account_title',
                ]

                for (let i in vars) {
                    x[vars[i]] = encrypt.decrypt(x[vars[i]])
                }

                return x
            })
        },
    )
}

async function removePrivateBankInfo(id) {
    return await instance.delete('/bank/remove_private_info/' + id)
}

async function deleteBank(id) {
    return await instance.delete('/bank/' + id)
}

export {
    insertBank,
    getCompanyBankNickNames,
    getBanks,
    removePrivateBankInfo,
    deleteBank,
}

